import { render, staticRenderFns } from "./addUpdate.vue?vue&type=template&id=dba9cd20&scoped=true&"
import script from "./addUpdate.vue?vue&type=script&lang=js&"
export * from "./addUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba9cd20",
  null
  
)

export default component.exports